<div class="info-panel" [style.top]="model.top" [style.left]="model.left">
    <div class="header">{{model.title}}</div>
   <div class="info-panel" [style.top]="model.top" [style.left]="model.left">
        <div class="header">{{model.title}}</div>
        <div class="image-container">
            <div class="spinner" *ngIf="isImageLoading"></div>
            <img [src]="model.imageUrl" (load)="onImageLoad()" (error)="onImageError()" *ngIf="!isLoadingError">
        </div>
    </div>
</div>
